export const GET_AMENDMENT_REVIEW_SUBJECT = (uuid: string) => `/${uuid}/review-subject`;
export const GET_AMENDMENT_CANDIDATE_PROFILE = (uuid: string) => `${uuid}/preview-payment`;
export const GET_AMENDMENT_TRANSACTION_INFO = (uuid: string) => `${uuid}/payment-success-details`;
